<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="12"
        :form-context="formContext"
        icon="inticon-documents"
        title="Schutzbrief"
        @save="saveBreakdownCoverFormData">
        <template v-if="formContext.permissions.canCreateRetroactiveChangesNote === true" v-slot:after-icons>
            <csp-retroactive-changes-modal :record-id="recordId" title="Schutzbrief Kunde"/>
        </template>
        <b-row v-if="showChangelogButton">
            <div class="col d-flex justify-content-end">
                <csp-changelog-modal :changelog-url="changelogUrl"/>
            </div>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                v-show="shouldDisplayInsuranceParent"
                class="col-12"
                :form-context="formContext"
                label="Versicherungskonzern"
                :options-loader="loadInsuranceParentOptions"
                property="insuranceParent"
                type="autocomplete">
                <template v-slot:display-value>
                    <span v-if="formContext.data.insuranceName"><b>{{ formContext.data.insuranceName }}</b><br></span>
                    <span v-if="formContext.data.insurancePhone">{{ formContext.data.insurancePhone }}<br></span>
                    <span v-if="formContext.data.insuranceEmail">
                            <a :href="'mailto:' + formContext.data.insuranceEmail">
                                {{ formContext.data.insuranceEmail }}
                            </a>
                        </span>
                </template>
            </csp-desktop-info-card-element>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-12"
                :form-context="formContext"
                label="Versicherungsnummer"
                property="insurancePolicyNr"
                type="text"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-12"
                :form-context="formContext"
                label="Konditionen"
                property="insuranceText"
                type="text"/>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'CustomerInsuranceBreakdownCover',
        mixins: [FormDataMixin],
        computed: {
            changelogUrl() {
                return '/api/desktop/records/' + this.recordId + '/customer/insurances/breakdown-cover/changelog';
            },
            shouldDisplayInsuranceParent() {
                if (this.formContext?.isInEditMode) {
                    return true;
                }
                return !this.formContext?.data['insuranceBranch'];
            },
            recordId() {
                return parseInt(this.$route.params.recordId);
            },
            showChangelogButton() {
                return this.formContext.data.isEntityNew === false
                    && !this.formContext.isInEditMode
                    && this.formContext.permissions.showChangelog === true;
            },
        },
        methods: {
            loadInsuranceParentOptions() {
                return recordRepository.getInsuranceBreakdownParentOptions(this.recordId);
            },
            saveBreakdownCoverFormData(formContext) {
                const saveFunction = (objectId, postData) => {
                    return recordRepository.saveCustomerInsuranceBreakdownCover(this.recordId, postData);
                }
                this.saveFormData(formContext, saveFunction, null).then(() => {
                });
            },
        },
    }
</script>
